var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-flex f-flex-center",style:({ height: _vm.bheight + 'px' })},[(!_vm.isShangyun)?_c('img',{attrs:{"width":"300px","src":require("../../../static/images/empty.png")}}):_c('img',{attrs:{"width":"300px","src":require("../../../static/images/sempty.png")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5b4371dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/emptypage/index.vue
// module id = null
// module chunks = 